const Palette = {
  // primary
  blue: '#2F9BD8',
  blueNavy: '#0C273A',
  green: '#23CA78',
  yellow: '#F6BB43',
  orange: '#D85D2F',
  red: '#D82F4B',
  purple: '#5E2FD8',
  white: '#FFFFFF',
  black: '#000000',

  // secondary
  blueInk: '#031725',
  blueDenim: '#104A77',
  blueSlate: '#3F7193',
  blueGrey: '#D4E2EC',
  blueWhite: '#EAF0F5',
  greenPine: '#047870',
  yellowGold: '#B5A075',
  yellowHoney: '#C9812D',
  orangeRust: '#7B2D0F',
  redCherry: '#800428',
  purpleGrape: '#451DAB',
};

export default Palette;
